import t from "unified-doc-search-micromatch";
import r from "vfile";
import e from "hast-util-raw";
import n from "hast-util-to-html";
import i from "hast-util-to-mdast";
import o from "hast-util-to-xast";
import a from "mdast-util-to-markdown";
import u from "mime-types";
import s from "xast-util-to-xml";
import c from "hast-util-to-string";
import f from "deepmerge";
import l from "hast-util-sanitize";
import m from "hast-util-sanitize/lib/github.json";
import p from "rehype-parse";
import d from "rehype-stringify";
import h from "remark-parse";
import v from "remark-rehype";
import g from "unified";
import y from "unified-doc-parse-code-block";
import x from "unified-doc-parse-csv";
import k from "unified-doc-util-mark";
var b,
    P = O;

function O(t) {
  if ("string" == typeof t) return function (t) {
    return function (r) {
      return Boolean(r && r.type === t);
    };
  }(t);
  if (null == t) return j;
  if ("object" == typeof t) return ("length" in t ? C : w)(t);
  if ("function" == typeof t) return t;
  throw new Error("Expected function, string, or object as test");
}

function w(t) {
  return function (r) {
    var e;

    for (e in t) {
      if (r[e] !== t[e]) return !1;
    }

    return !0;
  };
}

function C(t) {
  var r = function (t) {
    for (var r = [], e = t.length, n = -1; ++n < e;) {
      r[n] = O(t[n]);
    }

    return r;
  }(t),
      e = r.length;

  return function () {
    for (var t = -1; ++t < e;) {
      if (r[t].apply(this, arguments)) return !0;
    }

    return !1;
  };
}

function j() {
  return !0;
}

function z(t) {
  return "head" !== t.tagName;
}

function A(t) {
  return c((r = t, e = z, n || (n = e, e = {}), o = null == (o = e.cascade) || o, i = P(n), function t(r, e, n) {
    var a, u, s, c;
    return i(r, e, n) ? (a = Object.keys(r).reduce(function (t, e) {
      return "children" !== e && (t[e] = r[e]), t;
    }, {}), r.children && (a.children = (u = r.children, s = function s(e, n) {
      return t(e, n, r);
    }, c = [], Array.isArray(u) ? (u.forEach(function (t, r, e) {
      var n = s.call(void 0, t, r, e);
      Array.isArray(n) ? c.push.apply(c, n) : null != n && c.push(n);
    }), c) : c), o && 0 !== r.children.length && 0 === a.children.length) ? null : a) : null;
  }(r, null, null)));
  var r, e, n, i, o;
}

function S(t) {
  return u.lookup(t) || "text/plain";
}

function E() {
  return (E = Object.assign || function (t) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

var M = ((b = {})["text/csv"] = [[x, {
  header: !0
}]], b["text/html"] = [p], b["text/markdown"] = [h, v], b),
    N = function N(t) {
  return function () {
    var r = arguments;
    return function (e) {
      return t.apply(void 0, [e].concat([].slice.call(r)));
    };
  };
};

function R(t, r) {
  r.data.textContent = A(t);
}

export default function (u) {
  void 0 === u && (u = {});

  var c = u.compiler,
      p = u.marks,
      h = void 0 === p ? [] : p,
      v = u.parsers,
      x = void 0 === v ? {} : v,
      b = u.postPlugins,
      P = void 0 === b ? [] : b,
      O = u.prePlugins,
      w = void 0 === O ? [] : O,
      C = u.sanitizeSchema,
      j = void 0 === C ? {} : C,
      z = u.searchAlgorithm,
      B = void 0 === z ? t : z,
      L = u.searchOptions,
      Q = void 0 === L ? {} : L,
      q = r({
    contents: u.content,
    basename: u.filename
  }),
      D = function (t) {
    void 0 === t && (t = {});
    var r = t.compiler,
        e = void 0 === r ? d : r,
        n = t.marks,
        i = void 0 === n ? [] : n,
        o = t.parsers,
        a = t.postPlugins,
        u = void 0 === a ? [] : a,
        s = t.prePlugins,
        c = void 0 === s ? [] : s,
        p = t.sanitizeSchema,
        h = t.vfile,
        v = E({}, M, void 0 === o ? M : o),
        x = [[y, {
      language: h.extname.slice(1)
    }]],
        b = g(),
        P = S(h.basename);

    function O() {
      return b.processSync(h);
    }

    return b.use(v[P] || x), b.use(c), b.use(N(k), i), b.use(function () {
      return R;
    }), b.use(u), p && b.use(N(l), f(m, p)), b.use(e), {
      compile: O,
      parse: function parse() {
        return b.runSync(b.parse(h));
      },
      textContent: function textContent() {
        return h.data.textContent || O(), h.data.textContent;
      }
    };
  }({
    compiler: c,
    marks: h,
    parsers: x,
    postPlugins: P,
    prePlugins: w,
    sanitizeSchema: j,
    vfile: q
  });

  return {
    compile: function compile() {
      return D.compile();
    },
    file: function file(t) {
      return function (t) {
        var r,
            u = t.extension,
            c = void 0 === u ? null : u,
            f = t.hast,
            l = void 0 === f ? null : f,
            m = t.vfile,
            p = c;

        switch (c) {
          case ".html":
            r = n(l);
            break;

          case ".md":
            r = a(i(l));
            break;

          case ".txt":
            r = A(l);
            break;

          case ".xml":
            var d = e({
              type: "element",
              tagName: "html",
              children: [l]
            });
            r = s(o(d));
            break;

          default:
            r = m.contents, p = m.extname;
        }

        return {
          content: r,
          extension: p,
          name: "" + m.stem + p,
          stem: m.stem,
          type: S(p)
        };
      }({
        extension: t,
        hast: this.parse(),
        vfile: q
      });
    },
    parse: function parse() {
      return D.parse();
    },
    search: function search(t, r) {
      void 0 === r && (r = {});
      var e = Q.minQueryLength,
          n = Q.snippetOffsetPadding,
          i = void 0 === n ? 100 : n;
      if (t.length < (void 0 === e ? 1 : e)) return [];
      var o = this.textContent();
      return function (t) {
        var r = t.content,
            e = t.snippetOffsetPadding;
        return t.searchResults.map(function (t) {
          var n = t.start,
              i = t.end,
              o = t.value;
          return E({}, t, {
            snippet: [r.slice(Math.max(0, n - e), n), o, r.slice(i, Math.min(r.length, i + e))]
          });
        });
      }({
        content: o,
        searchResults: B(o, t, r),
        snippetOffsetPadding: i
      });
    },
    textContent: function textContent() {
      return D.textContent();
    }
  };
}